export default __webpack_public_path__ + "static/media/illustration_right.573fcf9e.png";